import * as React from "react";
import Check from "./check";
import SearchDesktop from "./searchDesktop";
import UserDesktop from "./userDesktop";
import SearchMobile from "./searchMobile";
import BurgerMenu from "./burgerMenu";
import Enquiryicon from "./enquiryIcon";
import Uploadicon from "./uploadIcon";
import SearchGrayIcon from "./searchGray";
import PlusIcon from "./plusIcon";
import Chevron from "./chevron";
import RightArrow from "./rightArrow";
import LeftArrow from "./leftArrow";
import Information from "./information";
import PencilDark from "./pencilDark";
import ListWhite from "./listWhite";
import ShoppingIcon from "./shoppingIcon";
import Whitetick from "./whiteTick";
import ArrowBack from "./arrowback";
import Filters from "./filters";
import PdfIcon from "./pdfdoc";
import PptIcon from "./ppt";
import Maildoc from "./mailDoc";
import Docdoc from "./Docdoc";
import Jpgdoc from "./JpgDoc";
import Pngdoc from "./Pngdoc";
import Xlsdoc from "./Xlsdoc";
import Downloadwhite from "./downloadWhite";
import DownloadBlue from "./downloadBlue";
import DeleteIcon from "./delete";
import Logout from "./logout";
import CLose from "./closeBurger";
import Whitelist from "./listWhite";
import CustomerDevelopment from "./customerDevelopment";
import SupplyChain from "./supplyChain";
import Itservice from "./itService";
import Finance from "./finance";
import Workplace from "./workplaceService";
import Legal from "./legal";
import IandA from "./IandA";
import RandD from "./RandD";
import Service from "./service";
import Cez from "./cez";
import Cez1 from "./cez1";
import Video from "./videoicon";
import Scrabble from "./scrabble";
import Redarrow from "./redArrow";
import Botinfo from "./botinfo";
import Requestbot from "./requestbot";
import Crown from "./crown";
import Grayicon from "./grayclose";
import ConversationalAi from "./ConversetionalAi";
import TestClassification from "./TestClassification";
import AnomalyDetection from "./AnomalyDetection";
import ImgVdoAnalytics from "./ImgVdoAnalytics";
import DocumentDigitalization from "./DocumentDigitalization";
import ThreeDots from "./threeDots";
import CrossIcon from "./crossIcon";
import Failure from "./failure"
import RPA from "./RPA";
import WebScrapping from "./WebScrapping";

export default class Icons extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    switch (this.props.name) {
      case "failure":
        return <Failure{...this.props} />;
      case "CrossIcon":
        return <CrossIcon{...this.props} />;
      case "threeDots":
        return <ThreeDots {...this.props} />;
      case "check":
        return <Check {...this.props} />;
      case "searchDesktop":
        return <SearchDesktop {...this.props} />;
      case "userDesktop":
        return <UserDesktop {...this.props} />;
      case "searchMobile":
        return <SearchMobile {...this.props} />;
      case "burgerMenu":
        return <BurgerMenu {...this.props} />;
      case "enquiryicon":
        return <Enquiryicon {...this.props} />;
      case "uploadicon":
        return <Uploadicon {...this.props} />;
      case "searchGrayIcon":
        return <SearchGrayIcon {...this.props} />;
      case "plusIcon":
        return <PlusIcon {...this.props} />;
      case "chevron":
        return <Chevron {...this.props} />;
      case "leftArrow":
        return <LeftArrow {...this.props} />;
      case "rightArrow":
        return <RightArrow {...this.props} />;
      case "information":
        return <Information {...this.props} />;
      case "pencilDark":
        return <PencilDark {...this.props} />;
      case "listWhite":
        return <ListWhite {...this.props} />;
      case "marketing":
        return <ShoppingIcon {...this.props} />;
      case "whitetick":
        return <Whitetick {...this.props} />;
      case "ppt":
        return <PptIcon {...this.props} />;
        case "pptx":
          return <PptIcon {...this.props} />;
      case "arrowback":
        return <ArrowBack {...this.props} />;
      case "filters":
        return <Filters {...this.props} />;
      case "pdf":
        return <PdfIcon {...this.props} />;
      case "msg":
        return <Maildoc {...this.props} />;
      case "xlsx":
        return <Xlsdoc {...this.props} />;
        case "xls":
          return <Xlsdoc {...this.props} />;
      case "Xlsx":    
           return <Xlsdoc {...this.props} />;
      case "jpg":
        return <Jpgdoc {...this.props} />;
      case "jpeg":
        return <Jpgdoc {...this.props} />;
      case "doc":
        return <Docdoc {...this.props} />;
      case "docx":
        return <Docdoc {...this.props} />;
      case "png":
        return <Pngdoc {...this.props} />;
      case "downloadWhite":
        return <Downloadwhite {...this.props} />;
      case "downloadBlue":
        return <DownloadBlue {...this.props} />;
      case "deleteicon":
        return <DeleteIcon {...this.props} />;
      case "logout":
        return <Logout {...this.props} />;
      case "closewhite":
        return <CLose {...this.props} />;
      case "whitelist":
        return <Whitelist {...this.props} />;
      case "customerDevelopment":
        return <CustomerDevelopment {...this.props} />;
      case "supplyChain":
        return <SupplyChain {...this.props} />;
      case "iTService":
        return <Itservice {...this.props} />;
       case "iTServices":
        return <Itservice {...this.props} />;
      case "finance":
        return <Finance {...this.props} />;
      case "workplaceService":
        return <Workplace {...this.props} />;
      case "workplaceServices":
        return <Workplace {...this.props}/>;  
      case "legal":
        return <Legal {...this.props} />;
      case "i&A":
        return <IandA {...this.props} />;
      case "r&D":
        return <RandD {...this.props} />;
      case "hRServices":
        return <Service {...this.props} />;
      case "hr":
        return <Service {...this.props} />; 
        case "hR":
        return <Service {...this.props} />; 
        case "hrService":
        return <Service {...this.props} />; 
      case "cez":
        return <Cez {...this.props} />;
      case "cezicon":
        return <Cez1 {...this.props} />;
      case "video":
        return <Video {...this.props} />;
      case "scrabble":
        return <Scrabble {...this.props} />;
      case "redarrow":
        return <Redarrow {...this.props} />;
      case "botinfo":
        return <Botinfo {...this.props} />;
      case "requestbot":
        return <Requestbot {...this.props} />;
      case "crown":
        return <Crown {...this.props} />;
      case "grayclose":
        return <Grayicon {...this.props} />;
      case "ConversationalAi":
        return <ConversationalAi {...this.props} />;
      case "RPA":
        return <RPA {...this.props} />;
      case "WebScrapping":
        return <WebScrapping {...this.props} />;
      case "TestClassification":
        return <TestClassification {...this.props} />;
      case "AnomalyDetection":
        return <AnomalyDetection {...this.props} />;
      case "ImgVdoAnalytics":
        return <ImgVdoAnalytics {...this.props} />;
      case "DocumentDigitalization":
        return <DocumentDigitalization {...this.props} />;
      case "ConversationAiSelected":
        return <ConversationalAiSelected {...this.props} />;
      default:
        return "";
    }
  }
}
